/* istanbul ignore file */

import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';

import { Observable } from 'rxjs';

import { HttpBaseService } from '../../../core';
import { environment } from '../../../environments/environment';
import { Feature } from '../../models/feature-flags';

@Injectable({
    providedIn: 'root'
})
export class FeatureFlagsDataService extends HttpBaseService {

    private route = environment.api + 'feature-flags/';

    constructor(
        private _httpClient: HttpClient,
    ) {
        super(_httpClient);
    }

    getFeatureFlags(): Observable<Feature> {
        const url = `${this.route}`;
        return this.httpGet(url);
    }
}
